import TravelerDetails from "./travelerDetails"

export default TravelerDetails